import Vue from "vue";

const observerCallback = (entries) => {
  entries.forEach((entry) => {
    const element = entry.target;
    const isIntersecting = entry.isIntersecting;

    if (isIntersecting) {
      element.classList.add("fade-animation");
    } else {
      element.classList.remove("fade-animation");
    }
  });
};

const observerOptions = { threshold: [0, 1.0] };

const intersectionObserver = new IntersectionObserver(
  observerCallback,
  observerOptions
);

Vue.directive("fade", {
  /**
   *
   * @param {HTMLElement} el
   */
  inserted: (el) => {
    el.classList.add("fade-before");

    intersectionObserver.observe(el);
  },
});
